export default {
    state: {
        language: "Ελληνικά",
    },
    mutations: {
        setLanguage(state, language) {
            state.language = language;
        },
        
    },
    actions: {
        setLanguage({commit}, language) {
            commit('setLanguage', language);
        },
    },
};